"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginPanelCms = void 0;
var LoginPanelCms = /** @class */ (function () {
    function LoginPanelCms() {
        this.loginMessage = 'You are eligible to discounts if you login, To login please ';
        this.loginLinkText = 'click here';
        this.successMessage = 'You have successfully logged in';
    }
    return LoginPanelCms;
}());
exports.LoginPanelCms = LoginPanelCms;
//# sourceMappingURL=loginPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/LoginPanel/loginPanel.cms.js
// module id = 2384
// module chunks = 8